import dotpRoutes from '@/modules/donations-over-the-phone/router.js';
import exportsDataRoutes from '@/modules/exports-data/router.js';
import supportersRoutes from '@/modules/supporters/router.js';
import usersRoutes from '@/modules/users/router.js';
import store from '@/store/index.js';
import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const baseRoutes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue'),
  },
  {
    path: '/sms/payment',
    name: 'smsPayment',
    component: () => import('../views/SmsPayment.vue'),
  },
  {
    path: '/forgot-password',
    name: 'forgotPassword',
    component: () => import('../views/ForgotPassword.vue'),
    meta: {
      requiresUnAuth: true,
    },
  },
  {
    path: '/reset-password',
    name: 'resetPassword',
    component: () => import('../views/ResetPassword.vue'),
    meta: {
      requiresUnAuth: true,
    },
  },
  {
    path: '/overview',
    name: 'overview',
    component: () => import('../views/Overview.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('../views/Home.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '',
    redirect: '/home',
  },
  {
    path: '*',
    redirect: '/home',
  },
  {
    path: '**',
    redirect: '/home',
  },
];

const routes = [].concat(
  // companiesRoutes,
  // pbiReportsRoutes,
  usersRoutes,
  // rolesRoutes,
  supportersRoutes,
  dotpRoutes,
  // securityGroupsRoutes,
  // pbiReportViewer,
  exportsDataRoutes,
  baseRoutes
);

const router = new Router({
  mode: 'history',
  routes,
});

router.beforeEach((to, _, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {

    let [moduleCode] = to.matched
      .map(e => e.meta.moduleCode)
      .filter(e => e);
    let [isSuperAdmin] = to.matched
      .map(e => e.meta.isSuperAdmin)
      .filter(e => e === true);

    store.dispatch('loading/start');

    store
      .dispatch('auth/canActivate', { module: moduleCode, isSuperAdmin })
      .then(() => {
        next();
      })
      .catch((err) => {
        if (err.noAccess) {
          next('/home');
        } else {
          console.error('Auth Guard: Failure', err);
          store.commit('auth/logout');
          next('/login');
        }
      })
      .finally(() => store.dispatch('loading/stop'));
  } else {
    next();
  }
});

export default router;
